import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './HotSpot.css';
import {connect} from "react-redux";
import {networkDeviceActions} from "../../actions/network-device.actions";
import DeviceTypeIcon from "../DeviceTypeIcon";
import ReactTooltip from "react-tooltip";
import HotSpotTooltipContent from "./HotSpotTooltipContent";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import {withNamespaces} from "react-i18next";
import ExhibitionMapForm from "../../layouts/Panel/ExhibitionMap/_forms/ExhibitionMapForm";
import {modalActions} from "../../actions/modal.actions";
import {exhibitionMapActions} from "../../actions/exhibition-map.actions";
import {claimTypes} from "../../constants/claim.constants";


class Hotspot extends Component {

    state = {
        hotspot: null,
        edit: false,
        editPosition: {
            x: undefined,
            y: undefined
        }
    };

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(networkDeviceActions.getNetworkDeviceList());


        this.setState({
            ...this.state,
            hotspot: this.props.hotspot
        });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(prevProps.hotspot !== this.props.hotspot) {
            this.setState({
                ...this.state,
                hotspot: this.props.hotspot
            })
        }
    }


    onSubmitEditHotspot = (data) => {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.editHotspot(data));
    };

    onClickEditHotspot = (e) => {
        e.preventDefault();

        const { t, dispatch } = this.props;
        const modalProps = {
            open: true,
            title: t('edit_exhibition-map-point'),
            component: <ExhibitionMapForm data={this.state.hotspot} submitForm={this.onSubmitEditHotspot}/>
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'formModal'
        }));
    };

    deleteHotspot = (id) => {
        const { dispatch } = this.props;
        dispatch(exhibitionMapActions.deleteHotspot(id))
    };

    onClickDeleteHotspot = (e) => {
        e.preventDefault();

        const { t, dispatch } = this.props;

        const modalProps = {
            open: true,
            title: t('are-you-sure'),
            message: t('delete-msg') + `<h5> ${this.state.hotspot.description} </h5>`,
            confirmLabel: t('delete-btn'),
            confirmIcon: 'fa-trash',
            classNameBtnConfirm: 'btn-danger',
            confirmAction: () => {
                this.deleteHotspot(this.state.hotspot.id);
                this.closeModalDelete();
            },
            closeModal: () => {
                this.closeModalDelete()
            }
        };

        dispatch(modalActions.showModal({
            modalProps: modalProps,
            modalType: 'confirm'
        }));
    };

    onClickEditPosition = (e) => {
        console.log('edit-position');
        this.setState({
            ...this.state,
            edit: true
        });
    };

    onClickAcceptPosition = (e) => {
        const { dispatch, mousePosition } = this.props;

        if(this.state.edit) {
            console.log(this.state.hotspot);
            const objectTemp = {...this.state.hotspot};
            objectTemp.x = mousePosition.posX;
            objectTemp.y = mousePosition.posY;

            this.setState({
                ...this.state,
                edit: false,
            });

            dispatch(exhibitionMapActions.editHotspot(objectTemp));
        }
    };

    closeModalDelete = () => {
        const { dispatch } = this.props;
        dispatch(modalActions.hideModal());
    };

    render () {
        const { t, mousePosition, user } = this.props;
        const { id, x, y, networkDevices} = this.props.hotspot;

        const claimMapCrud = user['c_map.actions.crud'] || null;

        let iconColor = "";
        const device = networkDevices[0];

        if(networkDevices) {
            if( networkDevices.length === 1 ) {

                switch(device.deviceType.label) {
                    case "PC":
                        iconColor = 'pc';
                        break;
                    case "LantickPro-4-4":
                        iconColor = 'iot';
                        break;
                    case "Dali router":
                        iconColor = 'iot';
                        break;
                    default:
                        iconColor = '';
                }
            }
            else {
                iconColor = "";
            }
        }


        const hotspotStyle = {
            position: 'absolute',
            display: 'block',
            top: (this.state.edit ? mousePosition.posY : y) + '%',
            left: (this.state.edit ? mousePosition.posX : x) + '%',
            pointerEvents: 'auto'
        };


        const HotSpot = ( networkDevices ?  (
            <React.Fragment>
                <ContextMenuTrigger id={"hotspot-" + id}>
                    <div
                        id={'drag-' + id}
                        className={"hotspot"}
                        style={hotspotStyle}
                        draggable={this.state.edit ? 'true' : 'false' }
                    >
                        <div
                            className={ "trigger " + iconColor }
                            data-tip="tooltip"
                            data-for={`hotspot-info-${id}`}
                            data-event={'click'}
                            onClick={this.onClickAcceptPosition}
                        >
                            { networkDevices.length === 1 ? (
                                <DeviceTypeIcon type={device?.deviceType.label} />
                            ) : (
                                <span><b>{ networkDevices?.length }</b></span>
                            ) }
                        </div>

                        <ReactTooltip
                            id={`hotspot-info-${id}`}
                            border={true}
                            clickable={true}
                            disable={this.state.edit}
                            isCapture={true}
                        >
                            { this.state.edit ? (
                                <div>
                                    {t('save-position')}
                                </div>
                            ) : (
                                <HotSpotTooltipContent networkDeviceList={networkDevices}  />
                            ) }

                        </ReactTooltip>

                    </div>
                </ContextMenuTrigger>

                { claimMapCrud === claimTypes.READ_WRITE ? (
                    <ContextMenu id={"hotspot-" + id}>
                            <MenuItem onClick={this.onClickEditPosition}>
                                <i className="fas fa-crosshairs" /> &nbsp;{ t('edit-position') }
                            </MenuItem>

                            <MenuItem onClick={this.onClickEditHotspot}>
                            <i className="fas fa-edit"/> &nbsp;{ t('edit') }
                            </MenuItem>

                            <MenuItem onClick={this.onClickDeleteHotspot}>
                            <i className="fas fa-trash"/> &nbsp; { t('delete-btn') }
                            </MenuItem>

                    </ContextMenu>
                ) : (
                    t('msg.not-permission')
                ) }

            </React.Fragment>


        ) : (<React.Fragment />) );

        return (
            HotSpot
        )
    }
}

Hotspot.propTypes = {
    hotspot: PropTypes.object,
};

const mapStateToProps = (state) => {
    const { list } = state.networkDeviceReducer;
    const { user } = state.authenticationReducer;
    return {
        list,
        user
    }
};

export default withNamespaces()(connect(mapStateToProps)(Hotspot))
